module.exports = __webpack_public_path__ + "img/charging-session-infograph-desktop.17ee2575.png";